import { Fieldset } from '@base-ui/react/fieldset';
import { SectionHeader } from '@/components/ui/SectionHeader';
import { Switch } from '@/components/ui/Switch';
import { cx } from '@/cva.config';
import { useScrapersSettings } from '@/providers/settings/SettingsContext';

export const ScrapersSection = () => {
  const { mark, scrapers, setScrapers } = useScrapersSettings();

  return (
    <>
      {/* Scrapers */}
      <Fieldset.Root>
        <Fieldset.Legend render={<SectionHeader>Scrapers</SectionHeader>} />
        <div className="overflow-hidden rounded-lg border border-border bg-surface/60">
          {scrapers.map((source, i) => (
            <div
              className={cx(
                'flex items-center justify-between px-4 py-3 gap-8',
                i < scrapers.length - 1 && 'border-b border-border',
              )}
              key={source.id}
            >
              <div className="flex items-center gap-3">
                <span
                  className={cx(
                    'size-2 rounded-full bg-border-active',
                    source.on && 'bg-score-high',
                  )}
                />
                <div>
                  <p className="text-sm lg:text-base text-foreground">
                    {source.label}
                  </p>
                  <p className="font-mono text-xs lg:text-sm text-subtle">
                    {source.notes}
                  </p>
                </div>
              </div>

              <div className="flex flex-col items-start w-62.5 gap-1">
                <Switch
                  checked={source.on}
                  label={`Toggle ${source.label}`}
                  onCheckedChange={(checked) =>
                    mark(setScrapers)(
                      scrapers.map((x) =>
                        x.id === source.id ? { ...x, on: checked } : x,
                      ),
                    )
                  }
                />
                <span className="font-mono text-xs lg:text-sm text-subtle tabular-nums pl-9">
                  last scan {Math.floor((source.id.charCodeAt(0) * 7) % 28) + 1}
                  m ago
                </span>
              </div>
            </div>
          ))}
        </div>
      </Fieldset.Root>
    </>
  );
};
